import { Card, CardBody, Row, Col, Button, FormFeedback } from "reactstrap"
import { LabelText } from "../Utils/Input"
import SelectField from "../Utils/SelectField"
import { DocumentUploadOptions } from "./constants/constantValues"
import InputField from "../Utils/InputField"
import { documentTableColumns } from "./constants/CustomerTableColumns"
import { useDispatch, useSelector } from "react-redux"
import { useState } from "react"
import { deleteDocument, emptyFieldsOfDocuments, getFile, handleChangeForDocumentName, handleChangeForDocumentType, payload, submitDocument, toggleModal, setFieldEmpty, verifyDocumentApiCall } from "./constants/HandleChangeFunctions"
import { customerIdData } from "./constants/constantFunctionsView"
import UploadDocumentTable from "./UploadDocumentTable"
import { ToastContainer, toast } from "react-toastify"
import { Loader } from "../Utils/Loader"
import { documentDataFunction } from "./constants/CustomerJsonObj"
import CommonModal from "../Utils/CommonModal"
import { deleteDoc } from "../../slices/customer/documentdelete/thunk"
import { clearDocFunction, displayVerifyModal, uploadSubmitFunction } from "./constants/DocumentTableFunctions"
import UploadDocumentTableForSelfcare from "./UploadDocumentTableSelfcare"

export default function UploadDocumentForSelfcare({ fetchDocumentData, isEdit, open, setIsOpen, file, setFile, fileName, setFileName, values, errors, touched, handleChange, handleBlur, setFieldValue, setFieldTouched, setState }) {
    const [messageForPopUp, setMessageForPopUp] = useState('')
    const [buttonText, setButtonText] = useState('')
    const [fields, setFields] = useState(false)
    const [loading, setLoading] = useState(false)
    const [editingRow, setEditingRow] = useState(null)
    const [editedDocumentName, setEditedDocumentName] = useState('');
    const [editedDocumentType, setEditedDocumentType] = useState(null);
    const [validationTriggered, setValidationTriggered] = useState(false);
    const [profileData, setProfileData] = useState()
    const roleName = localStorage.getItem('roleName')

    const customerId = roleName === "Customer"
        ? localStorage.getItem('customerId')
        : customerIdData();
    const [fileSizeValid, setFileSizeValid] = useState(true);
    const dispatch = useDispatch()
    let approvePayload = {}
    let rejectPayload = {}
    let documentsOfCustomer = []
    let partnerOrCustomer = ""
    documentsOfCustomer = documentDataFunction(fetchDocumentData)

    const columns = documentTableColumns(documentsOfCustomer, open, setIsOpen, setButtonText, setMessageForPopUp, fields, setFields, handleChange, editingRow, editedDocumentName, setEditedDocumentName, editedDocumentType, setEditedDocumentType, customerId, approvePayload, rejectPayload, dispatch, setLoading)

    return (
        <div>
            {isEdit && (
                <>
                    {loading && (<Loader />)}
                       <div className="d-flex flex-column flex-md-row">
                            <h5 className="rv-page-title mb-3">
                                {"Document Upload & Listing"}
                            </h5>
                        </div>
                    <div className="mb-3 mt-1 mx-1 border table-responsive p-4 rounded-1">
                        <div className="d-flex flex-column flex-md-row">
                            <h5 className="rv-page-title mb-3">
                                {"Document Upload"}
                            </h5>
                        </div>
                        <Row className="gy-4">
                            <Col xxl={3} md={6}>
                                <LabelText displayText={"Document Type"} important={"*"} className={"text-danger"} />
                                 <p className="text-muted fs-6">Select Document Type</p>
                                <SelectField
                                    handleChange={handleChangeForDocumentType(setFieldValue, setFieldTouched, setState)}
                                    className={errors.documentType && touched.documentType ? 'error-input' : ''}
                                    name={'documentType'}
                                    value={values.documentType}
                                    options={DocumentUploadOptions}
                                />
                                {touched.documentType && errors.documentType ? (
                                    <p className="text-danger">{errors.documentType}</p>
                                ) : null}
                            </Col>
                            <Col xxl={3} md={6}>
                                <LabelText htmlFor={"documentName"} displayText={"Document Name"} important={"*"} className={"text-danger"} />
                              <p className="text-muted fs-6">Enter Document Name</p>
                                <InputField
                                    name={"documentName"}
                                    type={"text"}
                                    className={"form-control"}
                                    handleChange={handleChangeForDocumentName(setState, handleChange)}
                                    handleBlur={handleBlur}
                                    value={values.documentName}
                                    invalid={touched.documentName && errors.documentName}
                                />
                                {touched.documentName && errors.documentName ? (
                                    <FormFeedback type="invalid">{errors.documentName}</FormFeedback>
                                ) : null}
                            </Col>
                            <Col xxl={3} md={6}>
                                <LabelText htmlFor={'selectedFile'} displayText={"Attachments"} important={"*"} className={"text-danger"} />
                              <p className="fs-6" style={{color: validationTriggered ? 'red' : 'text-muted'}}>File size should be less than 10 mb</p>
                                <InputField
                                    name={"selectedFile"}
                                    className={'form-control'}
                                    handleBlur={handleBlur}
                                    accept={'.png, .jpg, .jpeg, .pdf'}
                                    handleChange={getFile(setFile, setFileName, handleChange, setState, setValidationTriggered, setFileSizeValid)}
                                    value={values.selectedFile}
                                    type={'file'}
                                    invalid={validationTriggered}
                                />
                                {/* {validationTriggered && (
                                    <FormFeedback type="invalid">
                                        {file ? "File size exceeds the limit (10MB)." : "Kindly select a file"}
                                    </FormFeedback>
                                )} */}
                            </Col>
                            <Col></Col>
                            <Col className="d-flex justify-content-end align-items-center mt-5">
                                <button
                                    type="button"
                                    className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap btn btn-secondary me-2 mt-5"
                                    onClick={() => clearDocFunction(emptyFieldsOfDocuments, setFieldValue)}
                                >
                                    <i className="ri-close-line label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                    <span className="px-2 ms-2 me-1 fw-bold">
                                        Cancel
                                    </span>
                                </button>
                                <button
                                    disabled={!file || !values.documentName || !fileSizeValid}
                                    type="submit"
                                    onClick={() => uploadSubmitFunction(values, file, customerId, dispatch, setLoading, setFieldEmpty, setFieldValue, setState, setFieldTouched)}
                                    class="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap btn btn-secondary mt-5"
                                >
                                    <i class="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>
                                    <span class="px-2 ms-2 me-1 fw-bold">
                                        Submit
                                    </span>
                                </button>
                            </Col>

                        </Row>
                    </div>
                    <div className="mb-3 mt-1 mx-1 border table-responsive rounded-1">
                        <UploadDocumentTableForSelfcare
                            setProfileData={setProfileData}
                            partnerOrCustomer={partnerOrCustomer}
                            setLoading={setLoading}
                            dispatch={dispatch}
                            customerId={customerId}
                            setIsOpen={setIsOpen}
                            open={open}
                            toggleModal={toggleModal}
                            setFields={setFields}
                            setEditingRow={setEditingRow}
                            setEditedDocumentName={setEditedDocumentName}
                            setEditedDocumentType={setEditedDocumentType}
                            deleteDocument={deleteDocument}
                            setButtonText={setButtonText}
                            setMessageForPopUp={setMessageForPopUp}
                            columns={columns}
                            docTableMockData={documentsOfCustomer}
                        />
                    </div>
                    {open && (
                        <CommonModal
                            toggle={() => toggleModal(setIsOpen, open)}
                            open={open}
                            messageForPopUp={messageForPopUp}
                            buttonText={buttonText}
                            modalAction={() => {
                                displayVerifyModal(buttonText, dispatch, payload, setLoading, customerId, setIsOpen, open)
                            }}
                        />
                    )}
                </>
            )}
        </div>
    )
}
